import { render } from "./settings-controllers-ManualDispatch.vue?vue&type=template&id=bb53aa42"
import script from "./settings-controllers-ManualDispatch.vue?vue&type=script&lang=js"
export * from "./settings-controllers-ManualDispatch.vue?vue&type=script&lang=js"

import "./settings-controllers-ManualDispatch.vue?vue&type=style&index=0&id=bb53aa42&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__